export const TILE_TYPES = {
    EMPTY: 'empty',
    WALL: 'wall',
    PATH: 'path',
    BUNNY: 'bunny',
    EXIT: 'exit',
    MONSTER: 'monster',
    FIXED: 'fwall',
  };